import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AddSocial from './AddSocial';
import { deleteSocial, loadSocial } from '../../Redux/Actions/ActionSocial';
import EditSocial from './EditSocial';
import ReactLoading from 'react-loading';

function SocialMedia() {
    let role = localStorage.getItem('roleA');
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [arr, setArr] = useState([]);
    const [open, setOpen] = useState(false)
    const [openEdit, setopenEdit] = useState(false)
    const social = useSelector(state => state.social_media.social)
    const loadingSocial = useSelector(state => state.social_media.loadingSocial)
    useEffect(() => {
        dispatch(loadSocial());
    }, [])
    const handleDelete = (id) => {
        dispatch(deleteSocial(id))
    }
    const handleEdit = (arr1) => {
        const formValues = {
            id: arr1.id,
            name: arr1.name,
            name_ar: arr1.name_ar
        };
        setArr(formValues);
        setopenEdit(true);
    }
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('socialmed')}</h2>
                    {
                        role !== '2' && (
                            <button onClick={() => setOpen(true)} >
                                <i className="fa fa-plus" ></i>
                                <span>{t('addSocial')}</span>
                            </button>
                        )
                    }
                </div>
                <div className='allFea' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    {
                        loadingSocial == false ? (
                            social.map((ff) => {
                                return (
                                    <div className='oneFea' >
                                        <img src={ff.image} />
                                        <h3>{ff.name}</h3>
                                        {
                        role !== '2' ? (
                                        <div className='actionFea' >
                                            <i className='fa fa-trash trashFea' onClick={() => handleDelete(ff.id)} ></i>
                                            <i className='fa fa-edit editFea' onClick={() => handleEdit(ff)} ></i>
                                        </div>
                                        ) : ''
                                    }
                                    </div>
                                )
                            })
                        ) : <div className="div_loading_normal" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                    }
                </div>
            </main>
            {
                open == true ? (
                    <AddSocial open={open} setOpen={setOpen} />
                ) : <></>
            }
            {
                openEdit == true ? (
                    <EditSocial arr={arr} open={openEdit} setOpen={setopenEdit} />
                ) : <></>
            }
        </>
    )
}

export default SocialMedia